module.exports = __webpack_public_path__ + "static/media/hero2.a310e585.jpeg";